import { useEffect, useRef, useState } from "react";

const AccountDropdown = ({ tabs, tab, setTab }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = tabs.find(t => t.id === tab);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} style={{ position: "relative", maxWidth: 280, marginBottom: 32 }}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "12px 16px", fontSize: "14px", fontWeight: 600, letterSpacing: "0.02em",
          background: "var(--surface)", color: "var(--text)", border: "1px solid var(--border)",
          borderRadius: "var(--radius)", cursor: "pointer", transition: "border-color 0.15s",
          borderColor: open ? "var(--accent)" : "var(--border)",
        }}
      >
        <span>{current?.label}</span>
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ transform: open ? "rotate(180deg)" : "rotate(0)", transition: "transform 0.2s ease" }}>
          <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, zIndex: 50,
          background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius)",
          boxShadow: "0 8px 24px rgba(0,0,0,0.4)", overflow: "hidden",
        }}>
          {tabs.map(t => (
            <button
              key={t.id}
              onClick={() => { setTab(t.id); setOpen(false); }}
              style={{
                width: "100%", textAlign: "left", padding: "11px 16px", fontSize: "13px", fontWeight: 500,
                background: t.id === tab ? "rgba(0,212,170,0.08)" : "transparent",
                color: t.id === tab ? "var(--accent)" : "var(--text-dim)",
                borderBottom: "1px solid var(--border)", cursor: "pointer",
                transition: "background 0.1s, color 0.1s",
              }}
              onMouseEnter={e => { if (t.id !== tab) { e.target.style.background = "rgba(255,255,255,0.03)"; e.target.style.color = "var(--text)"; } }}
              onMouseLeave={e => { if (t.id !== tab) { e.target.style.background = "transparent"; e.target.style.color = "var(--text-dim)"; } }}
            >{t.label}</button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AccountDropdown;
